import { tabAccessControl } from "../../../_helpers/access-control";

function BankAccountTransferTabs(id){
  return [
  {
    text: "Transactions",
    path: `/bank-accounts-transaction/review/${id}`,
    applicationFeatureCode: "BankAccounts",
  },
  {
    text: "Reconcile",
    path: `/bank-reconciliation/edit/${id}`,
    applicationFeatureCode: "BankReconciliation",
  },

];
}

 function GetIndexByTabName(tabName,id){
  return tabAccessControl(BankAccountTransferTabs(id)).findIndex((x) => x.text == tabName);
}
 
export { BankAccountTransferTabs, GetIndexByTabName };